<template>
    <div/>
</template>

<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import { Validator } from 'vee-validate';
    export default {
        name: 'fedex-validator',
        validator: null,
        data: function () {
            return this.getDefaultData();
        },
        created: function () {
            Event.$on('validateAddress', this.onValidateAddress);
            this.validator = new Validator();
            this.validator.attach('address1', 'required', { prettyName: 'Address 1' });
            this.validator.attach('city', 'required', { prettyName: 'City' });
            this.validator.attach('state_prov', 'required', { prettyName: 'State/Province' });
            this.validator.attach('postal_code', 'required|min:5', { prettyName: 'Postal Code' });
            this.validator.attach('country', 'required', { prettyName: 'Country' });
        },
        beforeDestroy: function () {
            Event.$off('validateAddress', this.onValidateAddress);
        },
        methods: {
            getDefaultData: function () {
                return {
                    // validation-related fields:
                    address1: '',
                    city: '',
                    state_prov: '',
                    postal_code: '',
                    country: 'US',
                    // result of FedEx validation:
                    address: {
                        address1: '',
                        city: '',
                        state_prov: '',
                        postal_code: '',
                        country: 'US'
                    },
                    callback: ''
                };
            },
            notify: function (output) {
                /* {
                 success: false,
                 message: '', // optional
                 address: { // optional
                 address1: '',
                 city: '',
                 state_prov: '',
                 postal_code: '',
                 country: 'US'
                 }
                 }; */
                if (this.callback.length > 0) {
                    Event.$emit(this.callback, output);
                }
            },
            onValidateAddress: function (data) {
                var self = this;
                var payload = {
                    address1: data.address1 || '',
                    city: data.city || '',
                    state_prov: data.state_prov || '',
                    postal_code: data.postal_code || '',
                    country: data.country || 'US'
                };
                self.callback = data.callback || '';
                // console.log('got payload: ', payload);
                this.validator.validateAll(payload).then(function () {
                    /* global FRS_API_HOST */
                    var endpoint = window.location.protocol + FRS_API_HOST + '/api/address/validate';
                    self.$http.post(endpoint, payload).then(function (response) {
                        // console.log('backend responded with: ', response.data);
                        if ('data' in response && 'success' in response.data) {
                            if (response.data.success && 'address' in response.data) {
                                Object.assign(self.address, response.data.address);
                                self.notify({success: true, address: self.address});
                            } else {
                                self.notify({
                                    success: false,
                                    message: response.data.message || ''
                                });
                            }
                        } else {
                            self.notify({
                                success: false,
                                message: 'Address validation failed.'
                            });
                        }
                    }, function (error) {
                        // console.log('Network error: ', error);
                        self.notify({
                            success: false,
                            message: 'Network error.'
                        });
                    });
                }).catch(function () {
                    // pre-validation of address failed, no need to bother FedEx
                    self.notify({success: false});
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// fedex-validator.vue?0a57b5f6